import themeStyles from 'highlight.js/styles/github.css?url'
import styles from './code-block.css?url'

export { CodeBlock } from './code-block'
export const codeBlockLinks = () => [
  { rel: 'stylesheet', href: themeStyles },
  { rel: 'stylesheet', href: styles },
]
